/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SecurityDeactivationModalAliases {
  FRAGMENT_INPUT_APP_CODE = 'fragment-input-app-code',
  LAYOUT_BASE_MFA = 'layout-base-mfa',
  MODAL_SECURITY_DEACTIVATION = 'modal-security-deactivation',
}
export { SecurityDeactivationModalAliases };
